import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'pt', 'es', 'jp', 'it', 'fr', 'gr', 'hi'],
    fallbackLng: 'en',
    detection: {
      // Align with App.tsx / ACV (localStorage key `language`, query `?language=`).
      order: ['queryString', 'localStorage', 'cookie', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupQuerystring: 'language',
      lookupLocalStorage: 'language',
    },
    backend: {
      // Version param forces browser to fetch fresh translations on each build
      loadPath: '/locales/{{lng}}/translation.json?v=20260729',
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
